import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';

const FAQSection = ({ faqs }) => {
  const [openCategory, setOpenCategory] = useState(Object.keys(faqs)[0] || null);
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleCategory = (category) => {
    setOpenCategory(openCategory === category ? null : category);
    setOpenFAQ(null); 
  };

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <div className="space-y-4">
      {Object.keys(faqs).map((category) => (
        <div key={category} className="border border-gray-200 rounded-lg overflow-hidden">
          {/* Categoría */}
          <button
            className="flex justify-between items-center w-full p-4 text-left text-lg font-semibold text-gray-800 bg-gray-50 hover:bg-gray-100 focus:outline-none transition-colors duration-200"
            onClick={() => toggleCategory(category)}
          >
            <span>{category}</span>
            <ChevronDownIcon 
              className={`w-6 h-6 text-gray-500 transform transition-transform duration-300 ${
                openCategory === category ? 'rotate-180' : ''
              }`} 
            />
          </button>
          {/* Preguntas dentro de la categoría */}
          <div className={`transition-all duration-300 ease-in-out overflow-hidden ${openCategory === category ? 'max-h-screen' : 'max-h-0'}`}>
            <div className="p-4 space-y-3 bg-white">
              {faqs[category].map((faq) => (
                <div key={faq.id} className="border-t border-gray-200 first:border-t-0">
                  {/* Pregunta */}
                  <button
                    className="flex justify-between items-center w-full py-3 text-left font-medium text-gray-700 hover:text-blue-600 focus:outline-none"
                    onClick={() => toggleFAQ(faq.id)}
                  >
                    <span className={openFAQ === faq.id ? 'text-blue-600' : ''}>{faq.question}</span>
                    <ChevronDownIcon 
                      className={`w-5 h-5 text-gray-400 flex-shrink-0 transform transition-transform duration-300 ${
                        openFAQ === faq.id ? 'rotate-180 text-blue-500' : ''
                      }`} 
                    />
                  </button>
                  {/* Respuesta */}
                  <div className={`transition-all duration-300 ease-in-out overflow-hidden ${openFAQ === faq.id ? 'max-h-screen' : 'max-h-0'}`}>
                    <div className="pb-3 pr-6 text-gray-600">
                      {faq.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQSection;
